var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('h1',[_vm._v("人脸识别")]),_vm._v(" "),_c('video',{attrs:{"id":"video","width":"320","height":"240","preload":"","autoplay":"","loop":"","muted":""},domProps:{"muted":true}}),_vm._v(" "),_c('canvas',{attrs:{"id":"canvas","width":"320","height":"240"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05072940","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/qrcodeview/CheckDisclose.vue
// module id = null
// module chunks = 